import { Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';
import Icon from '../Icon/Icon';

export type IconButtonProps = ButtonProps & {
    icon: string;
    'aria-label': string;
};

const IconButton = React.forwardRef(function ({
    icon,
    width = '24px',
    height = '24px',
    minW = width,
    padding = '0px',
    ...props
}: IconButtonProps, ref: any) {
    return (
        <Button
            width={width}
            height={height}
            minW={minW}
            padding={padding}
            _focus={{
                border: '0px',
                backgroundColor: 'transparent',
                outline: 'none',
            }}
            _active={{ border: '0px' }}
            {...props}>
            <Icon
                name={icon}
                width={width}
                height={height}
            />
        </Button>
    );
});

export default IconButton;
